export const contactInit = () => {
    let rFunc = () => {};

    if (document.body.classList.contains("page-contact")) {
        const form = document.querySelector(".mw_wp_form form");
        const btn = document.querySelector(".form__innerSubmit .Arrowbtn");

        if (form) {
            const btnOnClick = (e) => {
                e.preventDefault(); // デフォルトの動作を防止
                form.submit(); // フォームをsubmit
            };
            btn?.addEventListener("click", btnOnClick);

            rFunc = () => {
                btn?.removeEventListener("click", btnOnClick);
            };
        }
    }
    return rFunc;
};
